import React from "react";
import { isRootlyBranded, isRootlyWhiteLabel } from "src/utils/brandTheme";

import RootlyFullLogo from "./rootly_logo";
import TierZeroIcon from "./tierzero";

interface ProductLogoProps {
  brandTheme?: string | null;
  tierzeroClassName?: string;
  rootlyClassName?: string;
  /** Show "powered by TierZero" for co-brand themes (ROOTLY_COBRAND, ROOTLY_HYBRID). */
  showPoweredBy?: boolean;
  poweredByClassName?: string;
}

const ProductLogo: React.FC<ProductLogoProps> = ({
  brandTheme,
  tierzeroClassName,
  rootlyClassName,
  showPoweredBy = false,
  poweredByClassName = "text-[11px] uppercase text-muted-foreground font-semibold leading-none",
}) => {
  // ROOTLY_HYBRID gets Rootly UI branding (per brand_theme spec) but is not "Rootly-branded" in the
  // backend sense — handle the logo case explicitly here.
  const isRootly = isRootlyBranded(brandTheme) || brandTheme === "ROOTLY_HYBRID";
  const showAttribution = showPoweredBy && isRootly && !isRootlyWhiteLabel(brandTheme);

  if (isRootly) {
    return (
      <div className="flex items-center gap-2">
        <RootlyFullLogo className={rootlyClassName ?? tierzeroClassName} />
        {showAttribution && (
          <span className={poweredByClassName}>
            {/* eslint-disable custom/no-hardcoded-brand-name -- intentional TierZero attribution for co-brand */}
            powered by TierZero
            {/* eslint-enable custom/no-hardcoded-brand-name */}
          </span>
        )}
      </div>
    );
  }
  return <TierZeroIcon className={tierzeroClassName} />;
};

export default ProductLogo;
